import { environment } from '../../../../../environments/environment';

export const INTERNAL_EMPLOYEES_ENDPOINT = `${environment.apiBaseUrl}/internal/portal/employees`;
export const INTERNAL_EMPLOYEE_GROUPS_ENDPOINT = `${environment.apiBaseUrl}/internal/portal/employee/groups`;
export const INTERNAL_EMPLOYEE_PERMISSIONS_ENDPOINT = `${environment.apiBaseUrl}/internal/portal/employee/permissions`;
export const INTERNAL_EMPLOYEE_GROUP_ASSIGN_ENDPOINT = (userToUpdateId: number) =>
  `${environment.apiBaseUrl}/internal/portal/employee/group/${userToUpdateId}`;
export const INTERNAL_EMPLOYEE_PROFILE_UPDATE_ENDPOINT = (userToUpdateId: number) =>
  `${environment.apiBaseUrl}/internal/portal/employee/profile/${userToUpdateId}`;
